import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Box, useTheme, CircularProgress } from '@mui/material';
export const FlexContainer = forwardRef(({ center, column, fullWidth, children, flexDirection, ...boxProps }, ref) => (_jsx(Box, { ref: ref, ...boxProps, display: 'flex', flexDirection: column ? 'column' : flexDirection, width: fullWidth ? '100%' : boxProps.width, alignItems: center ? 'center' : boxProps.alignItems, justifyContent: center ? 'center' : boxProps.justifyContent, children: children })));
FlexContainer.displayName = 'FlexContainer';
export const RowContainer = ({ children, ...rest }) => {
    const theme = useTheme();
    return (_jsx(FlexContainer, { marginY: theme.spacing(1), ...rest, children: children }));
};
export const SectionContainer = ({ children, ...rest }) => {
    const theme = useTheme();
    return (_jsx(FlexContainer, { marginX: theme.spacing(2), marginY: theme.spacing(2), ...rest, children: children }));
};
export const LoadingContainer = ({ cover, sx, ...props }) => {
    const theme = useTheme();
    let sxProp;
    if (cover) {
        const coverProps = {
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 10000,
        };
        if (typeof sx === 'function') {
            sxProp = {
                ...sx(theme),
                ...coverProps,
            };
        }
        else {
            sxProp = {
                ...sx,
                ...coverProps,
            };
        }
    }
    return (_jsx(FlexContainer, { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flexGrow: 1, ...props, sx: {
            ...sxProp,
        }, children: _jsx(CircularProgress, {}) }));
};
